// instrumentation-client.ts (client-side only)
import type { PostHog } from 'posthog-js'

// Initialize PostHog only in the browser and when env is present
let posthogRef: PostHog | null = null

async function ensurePosthogLoaded(): Promise<PostHog | null> {
  if (posthogRef) return posthogRef
  if (typeof window === 'undefined') return null
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY || !process.env.NEXT_PUBLIC_POSTHOG_HOST) return null
  try {
    const { default: posthog } = await import('posthog-js')
    // Disable heavy extensions to avoid recorder.js & surveys.js
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
      capture_performance: { web_vitals: false },
      autocapture: true,
      // Prevent loading session recording & surveys payloads
      disable_session_recording: true,
      disable_surveys: true,
      disable_surveys_automatic_display: true,
      disable_external_dependency_loading: true,
      loaded: (ph) => {
        posthogRef = ph
      }
    })
    return posthogRef
  } catch {
    return null
  }
}

export const isPostHogEnabled = () =>
  typeof window !== 'undefined' && !!process.env.NEXT_PUBLIC_POSTHOG_KEY && !!process.env.NEXT_PUBLIC_POSTHOG_HOST

export const capturePH = (event: string, properties?: Record<string, any>) => {
  try {
    if (!isPostHogEnabled()) return
    // Fire-and-forget; lazy load PH on first capture to defer loading off critical path
    ensurePosthogLoaded().then((ph) => {
      try { ph?.capture(event, properties) } catch {}
    })
  } catch (_) {
    // swallow to avoid breaking UX
  }
}

export { ensurePosthogLoaded }
            